import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppToastService } from "src/app/components/toasts/app-toast.service";
import { HttpKioskService } from "../../../../http-kiosk.service";
import { AuditDataDto, AuditDataDtoWithGroup, AuditProcessRequestTypeEnum, CustomerPayloadDto, FailedTxDto, KioskDto, ReportDayEndDto } from "../../../../dto";
import { ActivatedRoute, Router } from "@angular/router";
import { catchError } from "rxjs/operators";
import { faArrowLeft, faCalendar, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { UtilService } from "../../../../util.service";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { UrlUtil } from "src/app/utils/url-util";
import { HttpFailedTxService } from "src/app/modules/kiosk/http-failed-tx.service";
import { HttpReportDayEndService } from "src/app/modules/kiosk/http-report-day-end.service";
import { HttpKioskAuditsService } from "src/app/modules/kiosk/http-kiosk-audits.service";

@Component({
	selector: 'app-kiosk-audits',
	templateUrl: './kiosk-audits.component.html',
	styleUrls: ['./kiosk-audits.component.scss']
})
export class KioskAuditsComponent {
	kiosk: KioskDto;
	@Output() reloadKiosk: EventEmitter<any> = new EventEmitter(); 
	back = faArrowLeft;

	util = UtilService;

	fromModel: NgbDateStruct;
	toModel: NgbDateStruct;

	processOptions = Object.values(AuditProcessRequestTypeEnum);
	processModel: AuditProcessRequestTypeEnum;

	date=faCalendar;
	search=faSearch;
	clearSearch=faTimes;

	audits: AuditDataDtoWithGroup[]

	constructor(
		private httpService: HttpKioskService,
		private httpAuditsService: HttpKioskAuditsService,
		private spinner: NgxSpinnerService,
		private toastService: AppToastService,
		private router: Router,) {
	}

	@Input() 
	set kioskData(kiosk: KioskDto) {
		if (!kiosk) {
			return;
		}

		this.kiosk = kiosk;
		this.fetchKioskAudits();
	}

	private fetchKioskAudits() {
		console.log('Fetching Audits for kiosk ID: ', this.kiosk.id);
		let from = new Date();
		if (this.fromModel !== undefined) {
			from.setFullYear(this.fromModel.year);
			from.setMonth(this.fromModel.month - 1);
			from.setDate(this.fromModel.day);
		} else {
			from.setDate(from.getDate() - 2);
		}

		let to = new Date();
		if (this.toModel !== undefined) {
			to.setFullYear(this.toModel.year);
			to.setMonth(this.toModel.month - 1);
			to.setDate(this.toModel.day);
		}

		UrlUtil.setParams(this.router, {from: from, to: to, kiosk: this.kiosk?.id});

		this.spinner.show();
		this.httpAuditsService.getAll(from, to, this.processModel, this.kiosk.id)
		.pipe(
			catchError(error => {
				this.spinner.hide();
				console.log('Error fetching Audits', error);
				this.toastService.showDanger({ content: 'Failed to fetch data: ' + (error.error ? error.error.error : error.message) });
				throw error;
			})
		)
		.subscribe(resp => {
			if (!resp.success) {
				this.toastService.showDanger({ content: resp.error });
			} else {
				this.audits = this.assignGroupIndexes(resp.audits);
			}
			this.spinner.hide();
		});
	}

	doSearch() {
		if (this.fromModel !== undefined && this.toModel === undefined) {
			this.toastService.showSecondary({ content: 'Please provide to date' });
			return;
		}
		if (this.toModel !== undefined && this.fromModel === undefined) {
			this.toastService.showSecondary({ content: 'Please provide from date' });
			return;
		}
		
		this.fetchKioskAudits();
	}

	assignGroupIndexes(data: AuditDataDto[]): AuditDataDtoWithGroup[] {
		let currentTxId: string | null = null;
		let groupIndex = -1;

		return data.map(row => {
			if (row.txId !== currentTxId) {
				groupIndex++;
				currentTxId = row.txId;
			}
			return { ...row, groupIndex };
		});
	}
}